import React from 'react';
import {connect} from 'react-redux';
import {useHistory} from 'react-router-dom';
import './EditAdmin.scss';
import PropTypes from 'prop-types';
import {useFormik} from 'formik';
import actions from '../../../redux/actions';
import * as yup from 'yup';
import _ from 'lodash';
import ArrowBackComponent from '../../../common/components/ArrowBack/ArrowBack';
import CustomInput from '../../../common/components/CustomInput/CustomInput';
import Button from '../../../common/components/Button/Button';
/**
 * @description
 * @param { object } props no redux
 * @return { * } component
 */
const InputErrorMessage = ({formik, name, className = ''}) => {
    return (
        <div className={'form-error ' + className}>
            {_.get(formik.touched, name) && _.get(formik.errors, name)}
        </div>
    );
};

const _EditAdmin = (props) => {
    const {
        name,
        adminSelected,
        putAdmin,
        currentUser,
        showSidebar,
    } = props;
    const validationSchema = yup.object({
        email: yup
            .string('Ingrese email')
            .email('email invalido')
            .required('Ingrese email'),
    });

    const history = useHistory();

    const handleArrowBack = () => {
        history.goBack();
    };

    const formik = useFormik({
        initialValues: {
            id: adminSelected?.id ? adminSelected?.id : '',
            email: adminSelected?.email || '',
            firstName: adminSelected?.firstName || '',
            lastName: adminSelected?.lastName || '',
            // password: '',
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            const body = {
                id: values.id,
                user: _.omit(values, ['id']),
            };
            putAdmin(body);
            history.goBack();
        },
    });

    return (
        <div className={showSidebar && window.innerWidth <= 700 ? 'ul-div-background bg-mt-1' : 'ul-div-background'}
             style={{backgroundColor: 'transparent', margin: '10px', padding: '10px'}}>
            <div className="admin-data-inner-container">

                <div className="ul-div-sect-header" style={{justifyContent: 'start'}}>
                    <div style={{width: '40px', height: '40px', marginRight: '20px'}}>
                        <ArrowBackComponent onClick={handleArrowBack} />
                    </div>
                    <p className="h3 v2-c-text-title">{currentUser ? 'Mis Datos' : 'EDITAR ADMINISTRADOR'}</p>
                </div>

                <form onSubmit={formik.handleSubmit} style={{width: '100%'}}>
                    <div className="change-pass-container change-pass">
                        <div style={{cursor: 'pointer'}}
                             onClick={() => history.push('/change_password')}>
                            Cambiar contraseña
                        </div>
                    </div>
                    <div style={{marginBottom: '20px', marginTop: '30px'}}>

                        <div style={{display: 'flex', gap: '20px', marginBottom: '20px'}}>
                            <CustomInput
                                label="Nombre"
                                disabled={false}
                                placeholder={formik.values.firstName}
                                value={formik.values.firstName}
                                onChange={(value) => formik.setFieldValue('firstName', value)}
                            />
                            <CustomInput
                                label="Apellido"
                                disabled={false}
                                placeholder={formik.values.lastName}
                                value={formik.values.lastName}
                                onChange={(value) => formik.setFieldValue('lastName', value)}
                            />
                        </div>

                    <div style={{display: 'flex', marginBottom: '20px', width: '49%'}}>
                    <CustomInput
                            label="Email *"
                            placeholder={formik.values.email}
                            disabled={false}
                            value={formik.values.email}
                        />

                    </div>

                        {formik.touched.email && formik.errors.email && (
                            <p className="body-3 c-text-error">{formik.errors.email}</p>
                        )}

                    </div>

                    <div style={{display: 'flex', justifyContent: 'center', marginTop: '20px'}}>
                        <Button type={'submit'} size={'medium'}>Guardar Cambios</Button>
                    </div>
                </form>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    name: localStorage.getItem('name'),
    users: state.home.users,
    columnData: state.home.columnData,
    title: state.home.title,
    adminSelected: state.home.adminSelected,
    showSidebar: state.common.showSidebar,
});

const mapDispatchToProps = (dispatch) => ({
    switchOfUser: (name) => dispatch(actions.home.switchOfUser(name)),
    putAdmin: (admin) => dispatch(actions.home.putAdminRequest(admin)),
});

_EditAdmin.propTypes = {
    name: PropTypes.string,
    title: PropTypes.string,
};


export default connect(mapStateToProps, mapDispatchToProps)(_EditAdmin);

